// extracted by mini-css-extract-plugin
module.exports = {"ekbtips-wrapper":"ekbtips-wrapper--3GnzYjed"};